module.exports = __webpack_public_path__ + "img/search.85959206.png";